import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { UserService } from "../../services";
import Accordion from "react-bootstrap/Accordion";
import { Stepper, Step, StepTitle } from "react-progress-stepper";
import { repairStatusNames } from "../../util/constants";
import { currentLanguage } from "../../util/common";
import { Icon, Notifications, Button } from "../shared";
import { Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import NotSatisfiedModal from "./NotSatisfiedModal";
import ScheduleCarPickupModal from "./ScheduleCarPickupModal";

const CarRepairProgress = ({ type, progress, getProgress, fastCollect = [], setLoading }) => {
  const { t } = useTranslation();
  const lang = currentLanguage();
  const carProgressRef = useRef(null);

  const [reasonModal, setReasonModal] = useState(false);
  const [scheduleCarModal, setScheduleCarModal] = useState(false);
  const [selectedCarDetails, setSelectedCarDetails] = useState({});
  const user = useSelector((state) => state.user.details);

  useEffect(() => {
    updateSeenStatus();
  }, [fastCollect]);

  const updateSeenStatus = () => {
    if (!fastCollect.length) return;

    // setLoading(true);
    fastCollect.forEach(async ({ carPlateNumber }) => {
      if (getUnseenNotifications(carPlateNumber).length) {
        await UserService.updateFastCollectSeenStatus({
          carPlateNumber,
          phoneNumber: user.mobilePhone,
          appointmentId: progress[0][0].appointmentId
        });
      }
    });
    // setLoading(false);
  };

  const getUnseenNotifications = (selectedCarPlate) => {
    const car = fastCollect.find(({ carPlateNumber }) => selectedCarPlate === carPlateNumber);
    if (car) return car.messages.filter(({ seen }) => !seen);
    else return [];
  };

  const getNotificationForCar = (selectedCarPlate) => {
    const carNotifications = fastCollect.find(
      ({ carPlateNumber }) => selectedCarPlate === carPlateNumber
    );
    return carNotifications || [];
  };

  // const createMasterStep = (masterStatus) => {
  //   return repairStatusNames[type].map((stepName, x) => {
  //     return x < 3 && masterStatus == x ? (
  //       <Step customContent={() => <div className="current-step" />} key={x}>
  //         <StepTitle>{t("track." + stepName)}</StepTitle>
  //       </Step>
  //     ) : x > 2 ? (
  //       <Step customContent={() => <Icon iconName="medal" />} key={x}>
  //         <StepTitle>{t("track." + stepName)}</StepTitle>
  //       </Step>
  //     ) : (
  //       <Step key={x}>
  //         <StepTitle>{t("track." + stepName)}</StepTitle>
  //       </Step>
  //     );
  //   });
  // };

  const createSubSteps = (status) => {
    return repairStatusNames[type].map(({ name, icon }, i) => {
      return (
        <Step
          customContent={() =>
            status === i ? (
              <div className="current-step" />
            ) : i > 2 ? (
              <Icon iconName="medal" />
            ) : status > i ? (
              <Icon iconName="check" />
            ) : (
              <Icon iconName={icon} />
            )
          }
          key={i}>
          <StepTitle>{t(name)}</StepTitle>
        </Step>
      );
    });
  };

  const handleScheduleCarModal = (selectedCarDetails) => {
    setSelectedCarDetails(selectedCarDetails);
    setScheduleCarModal(true);
  };

  const handleNotSatisfiedModal = (selectedCarDetails) => {
    setSelectedCarDetails(selectedCarDetails);
    setReasonModal(true);
  };

  const handleCloseModals = () => {
    setSelectedCarDetails({});
    setReasonModal(false);
    setScheduleCarModal(false);
  };

  return (
    <>
      <div className="col-md-12 col-xl-4">
        <div className="car-service-progress" ref={carProgressRef}>
          <div className="head">
            <h2>{t("track.vehicleStatus")}</h2>
            <p>{t("track.vehicleStatusPara")}</p>
          </div>

          <Accordion flush defaultActiveKey={0}>
            {progress.map((carsEstimation, i) => {
              const carEstimation = carsEstimation[0];
              let estimatedDate = carEstimation.actual_promise_date?.[lang];
              // estimatedDate = estimatedDate ? estimatedDate + "*" : "";
              const carPlateNumber = carEstimation.plateNumber + carEstimation.plateLetter;
              const fastCollectData = getNotificationForCar(carPlateNumber);

              return (
                <React.Fragment key={i}>
                  <Accordion.Item eventKey={i} key={i} className={estimatedDate && "dated"}>
                    <Accordion.Header className="car-progress">
                      <div className="status-for">
                        <h4>{carEstimation.name}</h4>
                        <span className="fa">
                          <span className="moreDetails">{t("track.moreDetails")}</span>
                          <Icon iconName="chevronDown" />
                        </span>
                      </div>
                      {/* <div className="col-md-8">
                    <p className="estimated-date">{estimatedDate}</p>
                    <Stepper step={carEstimation.status} numbered={false}>
                      {createMasterStep(carEstimation.status)}
                    </Stepper>
                    {estimatedDate && (
                      <p className="estimated-msg collapsed">
                        <span>{t("track.estimatedCompleteDate")}</span>
                      </p>
                    )}
                  </div> */}
                    </Accordion.Header>
                    <Accordion.Body className="p-0">
                      <Accordion flush className="per-car-progress" defaultChecked>
                        {carsEstimation.map((data, x) => {
                          return (
                            <div key={x}>
                              <div className="status-for">
                                <h6>
                                  {data.estimation_ref_num && (
                                    <>
                                      <span>{data.estimation_ref_num}</span>
                                      <br />
                                    </>
                                  )}
                                  <span>{data.serviceType["value_" + lang]}</span>
                                </h6>
                              </div>
                              <div className="detail-body">
                                <Stepper step={data.status} numbered={false} vertical={true}>
                                  {createSubSteps(data.status)}
                                </Stepper>
                              </div>
                            </div>
                          );
                        })}
                      </Accordion>
                      {estimatedDate && (
                        <p className="estimated-msg">
                          <span>{t("track.estimatedCompleteDate")} </span>
                          {estimatedDate}
                        </p>
                      )}
                    </Accordion.Body>

                    {fastCollectData.messages?.length ? (
                      <div className="notifications-container fast-collect-notifications">
                        <div className="notification-icon fast-collect-bell">
                          <h4>{t("track.fastCollectHeading")}</h4>
                          <Icon iconName="bell" />
                          <Badge className="badge-icon" bg="warning">
                            {getUnseenNotifications(carPlateNumber).length}
                          </Badge>
                        </div>
                        <Notifications
                          messages={fastCollectData.messages}
                          showNoResults={false}
                          allowSlicing={true}
                          parentRef={carProgressRef}
                        />

                        {fastCollectData.repairStatus === "completed" &&
                          !fastCollectData.isCustomerSatisfied && (
                            <div className="satisfied-not-satisfied-btns">
                              <Button
                                type="small-roundedLeft"
                                customize="secondary"
                                action={() =>
                                  handleNotSatisfiedModal({
                                    ...fastCollectData,
                                    ...carEstimation
                                  })
                                }>
                                {t("track.notSatisfied")}
                              </Button>
                              <Button
                                type="blue-roundedRight"
                                action={() =>
                                  handleScheduleCarModal({
                                    ...fastCollectData,
                                    ...carEstimation
                                  })
                                }>
                                {t("track.satisfied")}
                              </Button>
                            </div>
                          )}
                      </div>
                    ) : null}
                  </Accordion.Item>
                </React.Fragment>
              );
            })}
          </Accordion>
        </div>
      </div>

      <ScheduleCarPickupModal
        show={scheduleCarModal}
        closeModal={handleCloseModals}
        carDetails={selectedCarDetails}
        setLoader={setLoading}
      />

      <NotSatisfiedModal
        show={reasonModal}
        closeModal={handleCloseModals}
        carDetails={selectedCarDetails}
        getProgress={getProgress}
        setLoader={setLoading}
      />
    </>
  );
};

export default React.memo(CarRepairProgress);
